import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { trim, isEqual } from "lodash";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
// UI Components
import BootstrapTable from "react-bootstrap-table-next"; // https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import { Row, Col, Container, Card, CardBody } from "reactstrap";

// Custom Components
import { Group } from "../../../utils/logger";
import Loader from "../../../components/Loader";
import Header from "./Header";
import MbIdLookUpFilter from "./MbIdFilter";
import {
  messageTableSchema,
  voiceTableSchema,
  emailTableSchema,
  smsTableSchema,
  defaultLookupSort,
  expandMessageRow,
  expandVoiceSmsEmailRow,
  preferenceTableSchema,
  dispositionTableSchema,
} from "./mbidTableSchemas";
import { getMbIdLookUpResult, getUniqueIdLookUpResult } from "../../../state/actions/adminActions";
import { isZeroLengthString } from "../../../utils/normalize";
import { toastr } from "react-redux-toastr";

const RECORDS_PER_PAGE = "mbIdLookUpPageSize";
class MbIdLookUp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mbIdFilter: {
        mbId: "",
        dt_create: moment().subtract(7, "d").startOf("day"),
        mbIdError: false,
        uniqueId: "",
        mbIdFetchList: [],
        mbIdSelectedOption: "",
        uniqueIdError: false,
      },
      uniqueIdLookUpResult: [],
      mbIdLookUpResult: {},
      recordsPerPage: localStorage.getItem(RECORDS_PER_PAGE) || 50,
    };

    this.LoggerGroup = new Group("MbId LookUp", { disable: true });
    this.onUserAction = this.onUserAction.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onClickUniqueIdFetch = this.onClickUniqueIdFetch.bind(this);
  }

  componentDidMount() {
    this.LoggerGroup.emit("Mounted").end();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const state = {};
    if (!isEqual(nextProps.mbIdLookUpResult, prevState.mbIdLookUpResult)) {
      state.mbIdLookUpResult = nextProps.mbIdLookUpResult;
    }
    if (!isEqual(nextProps.mbIdLoading, prevState.mbIdLoading)) {
      state.mbIdLoading = nextProps.mbIdLoading;
    }
    if (!isEqual(nextProps.uniqueIdLoading, prevState.uniqueIdLoading)) {
      state.uniqueIdLoading = nextProps.uniqueIdLoading;
    }

    if (!isEqual(nextProps.uniqueIdLookUpResult, prevState.uniqueIdLookUpResult)) {
      const uniqueIdLookUpResult = nextProps.uniqueIdLookUpResult;
      const hasData = Array.isArray(uniqueIdLookUpResult) && uniqueIdLookUpResult.length > 0;
      state.uniqueIdLookUpResult = hasData ? uniqueIdLookUpResult : [];
      state.mbIdFilter = prevState.mbIdFilter;
      if (hasData) {
        state.mbIdFilter.mbIdFetchList = uniqueIdLookUpResult.reduce((newList, item) => {
          if (newList.indexOf(item.mbid) === -1) newList.push(item.mbid);
          return newList;
        }, []);
      } else {
        state.mbIdFilter.mbIdFetchList = [];
      }
      return state;
    }
  }

  onUserAction(propName, propValue) {
    this.LoggerGroup.emit("MBId LookUp User Action triggered", {
      dir: { propName, propValue },
    }).end();
    let mbIdError;
    switch (propName) {
      case "mbIdSelect":
        mbIdError = !propValue || trim(propValue.value) === "";
        this.setState({
          mbIdFilter: {
            ...this.state.mbIdFilter,
            mbIdSelectedOption: propValue,
            mbId: trim(propValue.value),
            mbIdError,
          },
        });
        break;
      case "mbId":
        mbIdError = !propValue || trim(propValue) === "";
        this.setState({
          mbIdFilter: { ...this.state.mbIdFilter, [propName]: trim(propValue), mbIdError },
        });
        break;
      case "uniqueId":
        const val = isZeroLengthString(propValue) ? "" : trim(propValue);
        if (!(this.state.mbIdFilter[propName] === val)) {
          this.setState({
            mbIdFilter: {
              ...this.state.mbIdFilter,
              [propName]: val,
              mbIdFetchList: [],
              mbId: "",
              mbIdSelectedOption: "",
            },
          });
        }
        break;
      case "dt_create":
        this.setState({ mbIdFilter: { ...this.state.mbIdFilter, [propName]: propValue } });
        break;
      default:
        alert("MBIdLookUp Unrecognised userAction Event triggered");
    }
    this.LoggerGroup.emit("User Action completed", { dir: { propName, propValue } }).end();
  }

  onClickUniqueIdFetch() {
    this.LoggerGroup.emit("UniqueId LookUp Search");
    const { uniqueId } = this.state.mbIdFilter;
    if (isZeroLengthString(uniqueId))
      return toastr.error("Please enter Unique Id for fetching related MbId list");
    this.props.getUniqueIdLookUpResult(uniqueId);
  }

  onSearch(e) {
    this.LoggerGroup.emit("MBId LookUp Search");
    e.stopPropagation();
    e.preventDefault();
    const { mbId } = this.state.mbIdFilter;
    if (!mbId || trim(mbId) === "") {
      this.setState({ mbIdFilter: { ...this.state.mbIdFilter, mbIdError: true } });
      return toastr.error("Enter MbId to be searched");
    }
    this.props.getMbIdLookUpResult({
      ...this.state.mbIdFilter,
      dt_create: moment(this.state.mbIdFilter.dt_create).format("YYYYMMDD"),
    });
    this.LoggerGroup.emit("MBId LookUp Search Finished");
  }

  render() {
    const { mbIdLoading, uniqueIdLoading } = this.props;
    const { messages, email, sms, voice, preference, disposition } = this.props.mbIdLookUpResult;

    return (
      <Container fluid className="p-0">
        <Header />
        <MbIdLookUpFilter
          onSearchClick={this.onSearch}
          loading={mbIdLoading || uniqueIdLoading}
          mbIdFilter={this.state.mbIdFilter}
          onUserAction={this.onUserAction}
          onClickUniqueIdFetch={this.onClickUniqueIdFetch}
        />
        {(mbIdLoading || uniqueIdLoading) && <Loader />}
        {!(mbIdLoading || uniqueIdLoading) && (
          <>
            <Card>
              <Row className="mb-2">
                <Col className="text-center">
                  <h4 className="text-muted">Message</h4>
                </Col>
              </Row>
              <CardBody>
                <BootstrapTable
                  bootstrap4
                  hover
                  classes="table-responsive-md"
                  keyField="id"
                  data={messages || []}
                  columns={messageTableSchema}
                  bordered={false}
                  defaultSorted={defaultLookupSort("messages")}
                  expandRow={expandMessageRow}
                />
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Row className="mb-2">
                  <Col className="text-center">
                    <h4 className="text-muted">Email</h4>
                  </Col>
                </Row>
                <BootstrapTable
                  bootstrap4
                  hover
                  classes="table-responsive-md"
                  keyField="emailevent_id_bint"
                  data={email || []}
                  columns={emailTableSchema}
                  bordered={false}
                  expandRow={expandVoiceSmsEmailRow("email")}
                  defaultSorted={defaultLookupSort("email")}
                />
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Row className="mb-2">
                  <Col className="text-center">
                    <h4 className="text-muted">SMS</h4>
                  </Col>
                </Row>
                <BootstrapTable
                  bootstrap4
                  hover
                  classes="table-responsive-md"
                  keyField="smsresults_id_bint"
                  data={sms || []}
                  columns={smsTableSchema}
                  bordered={false}
                  defaultSorted={defaultLookupSort("sms")}
                  expandRow={expandVoiceSmsEmailRow("sms")}
                />
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Row className="mb-2">
                  <Col className="text-center">
                    <h4 className="text-muted">Voice</h4>
                  </Col>
                </Row>
                <BootstrapTable
                  bootstrap4
                  hover
                  classes="table-responsive-md"
                  keyField="voicesent_id_bint"
                  data={voice || []}
                  columns={voiceTableSchema}
                  bordered={false}
                  defaultSorted={defaultLookupSort("voice")}
                  expandRow={expandVoiceSmsEmailRow("voice")}
                />
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Row className="mb-2">
                  <Col className="text-center">
                    <h4 className="text-muted">Disposition File</h4>
                  </Col>
                </Row>
                <BootstrapTable
                  bootstrap4
                  hover
                  classes="table-responsive-md"
                  keyField="recordTimeStamp"
                  data={disposition || []}
                  columns={dispositionTableSchema}
                  bordered={false}
                  expandRow={expandVoiceSmsEmailRow("disposition")}
                />
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <Row className="mb-2">
                  <Col className="text-center">
                    <h4 className="text-muted">Account Preferences</h4>
                  </Col>
                </Row>
                <BootstrapTable
                  bootstrap4
                  hover
                  classes="table-responsive-md"
                  keyField="id"
                  data={preference || []}
                  columns={preferenceTableSchema}
                  bordered={false}
                  pagination={paginationFactory({
                    sizePerPage: Number(this.state.recordsPerPage),
                    sizePerPageList: [5, 10, 25, 50, 75, 100],
                    onSizePerPageChange: (sizePerPage) => {
                      localStorage.setItem(RECORDS_PER_PAGE, sizePerPage);
                    },
                  })}
                />
              </CardBody>
            </Card>
          </>
        )}
      </Container>
    );
  }
}

MbIdLookUp.propTypes = {
  errors: PropTypes.object.isRequired,
  mbIdLoading: PropTypes.bool.isRequired,
  uniqueIdLoading: PropTypes.bool.isRequired,
  mbIdLookUpResult: PropTypes.object.isRequired,
  uniqueIdLookUpResult: PropTypes.object.isRequired,
  getMbIdLookUpResult: PropTypes.func.isRequired,
  getUniqueIdLookUpResult: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  errors: state.admin.errors,
  mbIdLoading: state.admin.loading.mbIdLookUpResult,
  uniqueIdLoading: state.admin.loading.uniqueIdLookUpResult,
  mbIdLookUpResult: state.admin.mbIdLookUpResult,
  uniqueIdLookUpResult: state.admin.uniqueIdLookUpResult,
});

export default connect(mapStateToProps, {
  getMbIdLookUpResult,
  getUniqueIdLookUpResult,
})(MbIdLookUp);
